// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__eyiHr"};